export default {
  authenticated: false,
  shopInfo: null,
  shop: null,
  shopName: null,
  shopToken: null, // jwt
};
